import { render, staticRenderFns } from "./categoryFav.vue?vue&type=template&id=3d783820&scoped=true&"
import script from "./categoryFav.vue?vue&type=script&lang=js&"
export * from "./categoryFav.vue?vue&type=script&lang=js&"
import style0 from "./categoryFav.vue?vue&type=style&index=0&id=3d783820&scoped=true&lang=css&"
import style1 from "./categoryFav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d783820",
  null
  
)

export default component.exports